import { createGlobalStyle } from 'styled-components';
import { styledScrollbar } from '.';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  body {
    background-color: ${(props) => props.theme.colors.background.normal};
    color: ${(props) => props.theme.colors.text.normal};
    text-rendering: optimizeLegibility;
  }

  html, body, input, textarea, button {
    font-size: ${(props) => props.theme.typography.fontSize}px;
    font-weight: 400;
  }

  input, textarea {
    color: #000;
  }

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.blue.medium};

    &:active {
      color: ${(props) => props.theme.colors.blue.medium};
    }

    &.danger {
      color: ${(props) => props.theme.colors.red.medium};
    }
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  .df-shadow {
    box-shadow: 0px 3px 4px #DBDCDC;
  }
  .df-padding-content {
    padding: 18px 24px;
  }

  /* scrollbar */
  ${styledScrollbar()}
`;

export default GlobalStyle;
